import { Company } from '../../models/company.model';

export class TorresCredentials {
  apiKey: string;
  /** The Company selected as the "interviniente" associated with the API key. */
  intermediary?: Company;
}
